import { onReady } from '../lib/on-ready.js';

function initOembed() {
    document.querySelectorAll('oembed').forEach((oembed) => {
        const url = oembed.getAttribute('url');
        let oembedUrl = '';

        if (url.includes('youtube.com')) {
            oembedUrl = `https://www.youtube.com/oembed?url=${url}`;
        }

        if (url.includes('vimeo.com')) {
            oembedUrl = `https://vimeo.com/api/oembed.json?url=${url}`;
        }

        if (!oembedUrl) {
            return;
        }

        fetch(oembedUrl)
            .then((response) => response.json())
            .then((data) => {
                const wrapper = document.createElement('div');
                wrapper.classList.add('ratio', 'ratio-21x9');
                wrapper.innerHTML = data.html;
                oembed.appendChild(wrapper);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    });
}

onReady(initOembed);
